import axios from 'axios';

export default {
  getTechSupports({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/tech-support/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertTechSupport', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeTechSupport({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      commit('removeTechSupportRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/tech-support/remove`,
        params: { id },
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeTechSupportRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeTechSupportRequestError', err);
          reject(err);
        });
    });
  },
  addTechSupport({ commit, state }, { payload, event }) {
    return new Promise((resolve, reject) => {
      commit('addTechSupportRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/tech-support/add`,
        params: payload,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addTechSupportRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addTechSupportRequestError', err);
          reject(err);
        });
    });
  },
  updateTechSupport({ commit, state }, { payload, event }) {
    return new Promise((resolve, reject) => {
      commit('updateTechSupportRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/tech-support/update`,
        params: payload,
        method: 'PUT'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('updateTechSupportRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('updateTechSupportRequestError', err);
          reject(err);
        });
    });
  }
};
